import { render, staticRenderFns } from "./StaffEdit.vue?vue&type=template&id=65f3c101&scoped=true&"
import script from "./StaffEdit.vue?vue&type=script&lang=js&"
export * from "./StaffEdit.vue?vue&type=script&lang=js&"
import style0 from "./StaffEdit.vue?vue&type=style&index=0&id=65f3c101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3c101",
  null
  
)

export default component.exports